import { render, staticRenderFns } from "./WithParallaxHeading.vue?vue&type=template&id=57c4fbeb&scoped=true&"
import script from "./WithParallaxHeading.vue?vue&type=script&lang=js&"
export * from "./WithParallaxHeading.vue?vue&type=script&lang=js&"
import style0 from "./WithParallaxHeading.vue?vue&type=style&index=0&id=57c4fbeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4fbeb",
  null
  
)

export default component.exports